import { type PopoverContentProps } from '@radix-ui/react-popover'
import { type ReactElement, type ReactNode } from 'react'

import { type IgnoreClickawayScopesType } from '@/utils/clickawayUtil'

export const FLOATING_COLLISION_PADDING = 16

export type FloatingPlacementType = 'bottom' | 'left' | 'right' | 'top'

export type FloatingInteractOutsideType = NonNullable<PopoverContentProps['onInteractOutside']>

export type FloatingBoxType = {
  borderColor?: 'light' | 'strong'
  content?: ReactNode
  disablePointerEvents?: boolean
  padding?: 'none'
  size?: 'lg'
  styled?: boolean
  variant?: 'box' | 'nobox'
  width?: 'full'
}

export type FloatingContentType = {
  ignoreScopes?: IgnoreClickawayScopesType
  placement?: FloatingPlacementType
} & FloatingBoxType

export type FloatingToggleType = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export type FloatingTriggerType = {
  children: ReactElement
} & FloatingContentType

export type FloatingHoverType = {
  isClickable?: boolean
} & FloatingTriggerType

export type FloatingPopoverType = {
  onInteractOutside?: FloatingInteractOutsideType
} & FloatingTriggerType

export type FloatingAnchoredType = {
  onInteractOutside?: FloatingInteractOutsideType
} & FloatingContentType &
  FloatingToggleType
